import { useLocation } from "react-router-dom";
import clinicalmetricsRegular from "./../../../assets/clinical_metrics.png";
import clinicalmetricsAlt from "./clinical_metrics_alt.svg";
import divinaAlt from "./logo-alt.svg";
import divinaRegular from "./logo.svg";

const logoPaths = {
    divina: {
        regular: divinaRegular,
        alt: divinaAlt,
    },
    clinicalmetrics: {
        regular: clinicalmetricsRegular,
        alt: clinicalmetricsAlt,
    },
};

const Logo = ({ alt }: { alt?: boolean }) => {
    const location = useLocation();

    // Determine the logo based on URL path
    const determineVersion = () => {
        if (location.pathname.includes("divina")) {
            return "divinagame";
        }
        return "clinicalmetrics"; // Default
    };

    const version = determineVersion();

    const versionD = {
        dfn: version === "divinagame",
        defaultLanguage: version === "divinagame" ? "de" : "en",
        logo: version,
        logoSrc: logoPaths[version === "divinagame" ? "divina" : "clinicalmetrics"],
        version,
    };

    return (
        <a href="/" className="cursor-pointer">
            <img
                src={alt ? versionD.logoSrc.alt : versionD.logoSrc.regular}
                className={version === "clinicalmetrics" ? "w-52" : ""}
                style={version === "clinicalmetrics" ? { position: "relative", top: ".18em", width: "13em" } : {}}
                alt={`${versionD.logo} logo`}
            />
        </a>
    );
};

export default Logo;
